Game.Utils.Hud = {


	coins: null,

	init: function( layers ) {

		this.coins = new Game.Prefabs.HudCounter( game, layers.groupHud );
		this.coins.setText( '000' );

	},


	addCoin: function() {

		var coinCount = ( this.coins.getValue() + 1 ).toString();
		coinCount = coinCount.padStart( 3, 0 );
		this.coins.setText( coinCount );

	},

};